import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { checkDetail } from "@event-chat/core";
import FormInput from "./FormInput.js";
import { FormItemProvider } from "./FormProvider.js";
import { useFormCom, useFormInstance, useFormItemEmit } from "./utils.js";
const FormItem = ({ async, children, initialValue, item, name, rules, schema, type, callback, debug, onChange, transform, ...props })=>{
    const { group, name: formName } = useFormInstance();
    const [inputRef, emit] = useFormItemEmit(item);
    const Form = useFormCom();
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(FormItemProvider, {
                emit: emit,
                children: /*#__PURE__*/ jsx(Form.Item, {
                    ...props,
                    initialValue: initialValue,
                    name: name,
                    rules: schema ? (rules ?? []).concat([
                        {
                            validator: (_, value)=>checkDetail(value, {
                                    async,
                                    schema
                                }),
                            transform
                        }
                    ]) : rules,
                    children: 'function' == typeof children ? (form)=>children({
                            ...form,
                            name: formName,
                            group,
                            emit
                        }) : children
                })
            }),
            void 0 !== name && /*#__PURE__*/ jsx(Form.Item, {
                ...props,
                name: name,
                rules: rules,
                hidden: true,
                children: /*#__PURE__*/ jsx(FormInput, {
                    async: async,
                    name: name,
                    ref: inputRef,
                    schema: schema,
                    type: type,
                    callback: callback,
                    debug: debug,
                    onChange: onChange
                })
            })
        ]
    });
};
const src_FormItem = FormItem;
export { src_FormItem as default };
